export interface PlayerAllSearchParams {
  tvshowId?: number | null
  seasonId?: number | null
  episodeId?: number | null
  channelId?: number | null
  showIndex?: number | null
  categoryId?: string | null
  vodId?: number | null
  channelNumber?: number | null
  featured?: boolean | null
  favorite?: boolean
  purchased?: boolean
}

export interface SearchParamsForPath {
  params: PlayerAllSearchParams
  path: string
}

export enum PlayerSubRoute {
  VOD = 'vod',
  SHOW = 'show',
  TV = 'tv',
  EVENT = 'event',
}
